<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <button class="btn btn-outline-primary" @click.prevent="backtolist">&lt; Return to list</button>
      <h3 class="mb-0 ms-4" v-if="company_id > 0">{{company_name}}</h3>
      <h3 class="mb-0 ms-4" v-if="company_id < 0">Add Company</h3>
    </div>
    <ul class="nav nav-tabs col-12 px-0 mx-0 mt-2" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active text-center w-100" id="general-tab" data-bs-toggle="tab" data-bs-target="#general" type="button" role="tab">
          General Information
        </button>
      </li>
    </ul>
    
    <div class="tab-content mt-3">
      <div class="tab-pane fade show active px-0 col-12 border-0" id="general" role="tabpanel">
        <div class="card border-0 mx-0 px-0 col-12">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-8">
                <form autocomplete="off" @submit.stop.prevent>
                  <!-- Company name -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Company name</label>
                    <div style="width: 58%;">
                      <input
                        id="company_name"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': company_name_valid === false }"
                        v-model="company_name"
                        @change="savefield('g_companies',company_id,'company_name',company_name)"
                        autocomplete="off"
                      >
                      <div class="invalid-feedback">Company name cannot be blank</div>
                    </div>
                  </div>

                  <!-- Company address -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Company address</label>
                    <div style="width: 58%;">
                      <input
                        id="company_address_1"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': company_address_valid === false }"
                        v-model="company_address_1"
                        @change="savefield('g_companies',company_id,'company_address_1',company_address_1)"
                        autocomplete="off"
                      >
                      <div class="invalid-feedback">Company address cannot be blank</div>
                    </div>
                  </div>

                  <!-- Company address 2 -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;"></label>
                    <div style="width: 58%;">
                      <input
                        id="company_address_2"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': company_address_valid === false }"
                        v-model="company_address_2"
                        @change="savefield('g_companies',company_id,'company_address_2',company_address_2)"
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <!-- Zip code -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Zip code</label>
                    <div style="width: 58%;">
                      <input
                        id="company_zip_code"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': company_address_valid === false }"
                        v-model="company_zip_code"
                        @change="savefield('g_companies',company_id,'company_zip_code',company_zip_code)"
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <!-- City -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">City</label>
                    <div style="width: 58%;">
                      <input
                        id="company_city"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': company_address_valid === false }"
                        v-model="company_city"
                        @change="savefield('g_companies',company_id,'company_city',company_city)"
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <!-- Country -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Country</label>
                    <div style="width: 58%;">
                      <select
                        id="company_country_id"
                        class="form-select"
                        :class="{ 'is-invalid': company_country_id_valid === false }"
                        v-model="company_country_id"
                        @change="savefield('g_companies',company_id,'company_country_id',company_country_id)"
                        autocomplete="off"
                      >
                        <option v-for="country in countries" :key="country.value" :value="country.value">
                          {{ country.text }}
                        </option>
                      </select>
                      <div class="invalid-feedback">You must select a country</div>
                    </div>
                  </div>

                  <!-- Company registration number -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Company registration number</label>
                    <div style="width: 58%;">
                      <input
                        id="company_registration_number"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': company_address_valid === false }"
                        v-model="company_registration_number"
                        @change="savefield('g_companies',company_id,'company_registration_number',company_registration_number)"
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <!-- Save button for new company -->
                  <div class="mt-4 d-flex" v-if="company_id < 1">
                    <div style="width: 33%; flex-shrink: 0;"></div>
                    <div style="width: 58%;">
                      <button
                        class="btn btn-primary"
                        @click.prevent="company_create"
                      >
                        Save New Company
                      </button>
                    </div>
                  </div>
                </form>

                <div v-if="company_id > 0" class="form-group col-12  text-start">
                  <span class="col-12 px-0 mx-0 pt-2 pb-4">Labels</span><br>
                  <span 
                    v-for="label in labels" 
                    :key="label.id" 
                    :style="{ 'background': '#'+label.color}" 
                    class="me-2 py-1 ps-2 pe-2 rounded"
                  >
                    {{ label.label }}
                    <span 
                      @click.stop.prevent="removelabel(label.id)"
                      class="ms-2"
                      style="cursor: pointer;"
                    >
                      <fa-icon name="trash-alt" />
                    </span>
                  </span>
                  <span 
                    v-show="addinglabel==0"
                    class="icon-plus pt-0 text-primary"
                    :class="labels.length==0?'pt-2':'pt-0'"
                    @click.stop.prevent="addlabel(company_id)"
                    style="cursor: pointer;"
                  >
                  </span>

                  <!-- Add label input -->
                  <div 
                    v-show="addinglabel==company_id"
                    class="input-group input-group-sm col-3 ps-0 ms-0 py-0 my-0 mt-2"
                  >
                    <input
                      class="form-control form-control-sm py-0"
                      v-model="addinglabeltext"
                      placeholder="Add label"
                      type="text"
                      @keyup.enter.prevent="saveaddlabel"
                      @keyup.escape.prevent="addinglabel = 0"
                      autocomplete="off"
                      ref="addinglabel"
                    >
                    <span class="input-group-text py-0">
                      <button
                        class="btn btn-link btn-sm p-0"
                        @click="addinglabel = 0"
                      >
                        X
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  name: 'Company',
  created() {
    this.countries_get();
    this.company_get();
  },
  data: function() {
    return {
      company_name: '',
      company_name_valid: null,
      company_address_1: '',
      company_address_valid: null,
      company_address_2: '',
      company_zip_code: '',
      company_zip_code_valid: null,
      company_city: '',
      company_city_valid: null,
      company_registration_number: '',
      company_registration_number_valid: null,
      company_country_id: 0,
      company_country_id_valid: null,
      countries: [],
      labels: [],
      addinglabel: 0,
      addinglabeltext: '',
      loading: true,
    }
  },
  computed: {
    company_id: {
      get() {
        return this.$store.state.currentcompany_id;
      }
    },
    emailinvalidfeedback() {
      if (this.email == '') { return "E-mail is invalid"; }
      // eslint-disable-next-line
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email) == false) {
        return "Incorrect e-mail format";
      }
      return "E-mail already exists";
    }
  },
  watch: {
    company_id: function() {
      this.company_get()
    }
  },
  methods: {
    checkform() {
      var formok = true;
      this.company_name_valid = true;
      if (this.company_name == '') { 
        this.company_name_valid = false; 
        formok = false;
      }
      return formok;
    },
    company_create() {
      if (this.checkform()) {
        var company = {
          company_name: this.company_name,
          company_address_1: this.company_address_1,
          company_address_2: this.company_address_2,
          company_zip_code: this.company_zip_code,
          company_city: this.company_city,
          company_country_id: this.company_country_id,
          company_registration_number: this.company_registration_number,
        }
        this.$store.dispatch('company_create', { company: company })
        .then((resp) => {
          var company_id = resp.data.id;
          this.$store.dispatch('company_setcurrent',{ company_id: company_id })
          .then(() => {
            this.company_get();
          });
        });
      }
    },
    savefield(tablename,id,fieldname,value) {
      if ( id > 0 ) {
        if (this.checkform()) {
          var record = {
            id: id,
            [fieldname]: value,
          }
          this.$store.dispatch('field_save', { tablename: tablename,record: record })
          .then(() => {
            this.$store.dispatch('companychanged_set',{ company_id: this.company_id });
          });
        }
      }
    },
    company_get() {
      this.company_name = '';
      this.labels = [];
      if (this.company_id > 0) {
        this.$store.dispatch('company_fetch', { company_id: this.company_id })
        .then((resp) => {
          this.company_name = resp.data.company_name;
          this.company_address_1 = resp.data.company_address_1;
          this.company_address_2 = resp.data.company_address_2;
          this.company_zip_code = resp.data.company_zip_code;
          this.company_city = resp.data.company_city;
          this.company_country_id = resp.data.company_country_id;
          this.company_registration_number = resp.data.company_registration_number;
          this.labels = resp.data.labels;
          this.loading = false;
        });
      }
    },
    backtolist() {
      this.$store.dispatch('company_setcurrent',{ company_id: 0 })
    },
    conslabels_get() {
      this.$store.dispatch('company_fetch', { company_id: this.company_id })
      .then((resp) => {
        this.labels = resp.data.labels;
      });
    },
    saveaddlabel() {
      if (this.addinglabeltext != '') {
        var savelabel = {
          company_id: this.addinglabel,
          label: this.addinglabeltext,
        }
        this.$store.dispatch('companylabel_add', { label: savelabel })
        .then(()=> {
          this.conslabels_get();
          this.$store.dispatch('companylabelchanged_set', { company_id: this.company_id });
        });
      }
      this.addinglabel = 0;
      this.addinglabeltext = '';
    },
    addlabel(id) {
      this.addinglabel = id;
      this.addinglabeltext = '';
      this.$nextTick(() => this.$refs.addinglabel.focus())
    },
    removelabel(companylabel_id) {
      this.$store.dispatch('companylabel_delete', { id: companylabel_id })
      .then(()=> {
        this.conslabels_get();
        this.$store.dispatch('companylabelchanged_set', { company_id: this.company_id });
      });
    },
    countries_get() {
      this.$store.dispatch('countries_fetch')
      .then((resp) => {
        this.countries = [];
        for (var i=0;i<resp.data.result.length;i++) {
          var countryoption = {
            value: resp.data.result[i].id,
            text: resp.data.result[i].country_name,
          }
          this.countries.push(countryoption);
        }
      });
    },
  }
}
</script>
